import React from 'react';
import {
  BooleanField,
  Create,
  Edit,
  EditButton,
  Filter,
  NullableBooleanInput,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  SelectInput,
  TextField,
  TextInput,
} from 'react-admin';
import { ZippityDatagrid, ZippitySimpleForm } from '../../components';
import ReferenceChild from '../../components/ReferenceChild';
import { perPage, getZ3PConfigValue } from '../../helper';
import ListWithCSVImport from '../../components/ListWithCSVImport';

const serviceLocations = getZ3PConfigValue('service_locations');
const hasWorkplaceServices = serviceLocations?.includes('workplace');

const LeadFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
    <ReferenceInput
      source="default_client_location_id"
      reference="client-location"
      sort={{ field: 'short_name', order: 'ASC' }}
      perPage={perPage}
      alwaysOn
      label={hasWorkplaceServices ? 'Client location' : 'Shop'}
    >
      <ReferenceChild
        {...props}
        optionText="short_name"
        source="default_client_location_id"
      />
    </ReferenceInput>
    <NullableBooleanInput source="has_customer_id" alwaysOn />
  </Filter>
);

export const LeadList = (props) => (
  <ListWithCSVImport
    filters={<LeadFilter />}
    bulkActionButtons={false}
    {...props}
  >
    <ZippityDatagrid rowClick="edit">
      <TextField source="created_at" />
      <TextField source="modified_at" />
      <TextField source="lead_id" />
      <TextField source="uuid" />
      <TextField source="email" />
      <TextField source="first_name" />
      <TextField source="last_name" />
      <TextField source="phone" />
      <TextField source="license_plate_number" />
      <TextField source="license_plate_state" />
      <TextField source="internal_note" />
      <ReferenceField
        source="client_location_id"
        reference="client-location"
        allowEmpty
        label={hasWorkplaceServices ? 'Client location' : 'Shop'}
      >
        <TextField source="short_name" />
      </ReferenceField>
      <ReferenceField source="customer_id" reference="customer" allowEmpty>
        <TextField source="email" />
      </ReferenceField>
      <TextField source="source" />
      <TextField source="source_detail" />
      <BooleanField source="has_customer_id" sortable={false} />
      <EditButton />
    </ZippityDatagrid>
  </ListWithCSVImport>
);

export const LeadEdit = (props) => (
  <Edit undoable={false} {...props}>
    <ZippitySimpleForm redirect="list">
      <TextInput source="email" />
      <TextInput source="first_name" />
      <TextInput source="last_name" />
      <TextInput source="phone" />
      <TextInput source="license_plate_number" />
      <TextInput source="license_plate_state" />
      <TextInput source="internal_note" fullWidth />
      <ReferenceInput
        source="client_location_id"
        reference="client-location"
        allowEmpty
        perPage={perPage}
        label={hasWorkplaceServices ? 'Client location' : 'Shop'}
      >
        <ReferenceChild
          {...props}
          optionText="short_name"
          source="client_location_id"
        />
      </ReferenceInput>
      <ReferenceInput source="customer_id" reference="customer" allowEmpty>
        <ReferenceChild {...props} optionText="email" source="customer_id" />
      </ReferenceInput>
      <TextInput source="source" />
      <TextInput source="source_detail" />
    </ZippitySimpleForm>
  </Edit>
);

export const LeadCreate = (props) => (
  <Create undoable={false} {...props}>
    <ZippitySimpleForm redirect="list">
      <TextInput source="email" />
      <TextInput source="first_name" />
      <TextInput source="last_name" />
      <TextInput source="phone" />
      <TextInput source="license_plate_number" />
      <TextInput source="license_plate_state" />
      <TextInput source="internal_note" fullWidth />
      <ReferenceInput
        source="client_location_id"
        reference="client-location"
        allowEmpty
        perPage={perPage}
        label={hasWorkplaceServices ? 'Client location' : 'Shop'}
      >
        <ReferenceChild
          {...props}
          optionText="short_name"
          source="client_location_id"
        />
      </ReferenceInput>
      <SelectInput
        source="source_type"
        choices={[{ id: '', name: '' }]}
        allowEmpty
      />
      <TextInput source="source_detail" />
    </ZippitySimpleForm>
  </Create>
);
